import "./TaxSolutions.module.css";
import Header from "@/reusable_sections/Header";
import TaxExpertise from "./sections/TaxExpertise";
import Advisory from "./sections/Advisory";
import StrategicPlan from "./sections/StrategicPlan";
import Footer from "@/reusable_sections/Footer";
export default function TaxSolutionsPage() {
  return <div>
      <Header />
      <TaxExpertise />
      <Advisory />
      <StrategicPlan />
      <Footer />
    </div>;
}